/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Icon from 'material/graphic/icon/icon';
import ToolTip from 'material/message/tooltip/tooltip';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageindicator/imageindicator_styles';



/* ========== ~~~~~~~~~~ IMAGE INDICATOR : INSTICATOR ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const ImageIndicator = (props) => {
    return (
        <ToolTip position={`top`} action={`mouseenter`} content={`Select an image`}>
            <Icon name={`image`} klass={`imageindicator ${props.classes.imageindicator}`} />
        </ToolTip>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ImageIndicator);